module.exports = ":host {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}"